import { FormikBag, FormikProps, withFormik } from 'formik';

import { cardWalletField } from './CardField';
import { WalletField } from './Field';
import { Errors, Form, genericForm, IWalletFormProps } from './Form';
import CardUtils from './util/card';

import { ICardCreateData } from 'components/Core/WalletForms/network/src/types';
import { getCardType } from 'components/Core/WalletForms/validations/src/cardNumber';
import { CardType } from 'components/Core/WalletForms/validations/src/types';

export interface ICardTokenCreateFormData extends ICardCreateData {
  expDate: string;
  zipCode: string;
  savePaymentMethod?: boolean;
  // Billing address fields
  street1?: string;
  city?: string;
  state?: string;
}

export interface ICreateCardTokenFormProps
  extends IWalletFormProps<ICardTokenCreateFormData, ICardCreateData> {
  initialValues?: ICardTokenCreateFormData;
  allowedCardTypes?: CardType[];
  zipCodeLength?: number;
  isInNameValidationExperiment?: boolean;
  /** When true, billing address fields (street1, city, state) are required */
  showBillingAddressFields?: boolean;
}
//@ts-ignore
export const CardField: WalletField<ICardTokenCreateFormData> = cardWalletField;
export type CreateCardTokenErrors = Errors<ICardTokenCreateFormData>;
export type CreateCardTokenFormikBag = FormikBag<
  ICreateCardTokenFormProps,
  ICardTokenCreateFormData
>;

const _CardTokenForm: Form<ICreateCardTokenFormProps, ICardTokenCreateFormData> = (
  props: FormikProps<ICardTokenCreateFormData> & ICreateCardTokenFormProps
) => {
  const {
    values: { number },
  } = props;
  props.values.cardType = getCardType(number);
  return genericForm(props);
};

export const CardTokenForm = withFormik<ICreateCardTokenFormProps, ICardTokenCreateFormData>({
  mapPropsToValues: CardUtils.getInitialFormValues,
  handleSubmit: CardUtils.handleSubmit,
  validate: CardUtils.validate,
  //@ts-ignore
})(_CardTokenForm);
